<template>
  <modal 
    name="DownloadModal" 
    :width="450" 
    :height="'auto'" 
    :adaptive="true" 
    class="premium-modal"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h2>Exportar Datos de Capa</h2>
        <button class="close-button" @click="$modal.hide('DownloadModal')">&times;</button>
      </div>

      <div class="modal-body">
        <p class="description">Seleccione el formato y el alcance de los datos que desea descargar.</p>

        <!-- Selección de Formato -->
        <div class="option-section">
          <label>Formato de Archivo</label>
          <div class="button-group">
            <button 
              :class="{ active: format === 'csv' }" 
              @click="format = 'csv'"
            >
              CSV (Excel)
            </button>
            <button 
              :class="{ active: format === 'geojson' }" 
              @click="format = 'geojson'"
            >
              GeoJSON
            </button>
          </div>
        </div>

        <!-- Selección de Alcance -->
        <div class="option-section">
          <label>Alcance de los Datos</label>
          <div class="selection-cards">
            <div 
              class="selection-card" 
              :class="{ active: useFilters }" 
              @click="useFilters = true"
            >
              <div class="card-title">Datos Filtrados</div>
              <div class="card-desc">Solo lo que se muestra actualmente con filtros aplicados.</div>
            </div>
            <div 
              class="selection-card" 
              :class="{ active: !useFilters }" 
              @click="useFilters = false"
            >
              <div class="card-title">Todos los Datos</div>
              <div class="card-desc">La capa completa sin filtros (límite de 10.000 registros).</div>
            </div>
          </div>
        </div>

        <div class="limit-info">
          <font-awesome-icon icon="info-circle" />
          <span>Máximo de 10.000 registros por descarga.</span>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" @click="$modal.hide('DownloadModal')">Cancelar</button>
        <button 
          class="btn btn-primary" 
          @click="executeDownload" 
          :disabled="loading"
        >
          <font-awesome-icon v-if="loading" icon="spinner" spin />
          {{ loading ? 'Preparando...' : 'Descargar' }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { attributesTableService } from "@/services/layers/attributesTable";

export default {
  name: "DownloadModal",
  data() {
    return {
      format: "csv",
      useFilters: true,
      loading: false
    };
  },
  computed: {
    layer() {
      return this.$store.getters["attributeTable/layer"];
    },
    columnFilters() {
      return this.$store.getters["attributeTable/columnFilters"];
    },
    spatialFilter() {
      return this.$store.getters["attributeTable/spatialFilter"];
    }
  },
  methods: {
    async executeDownload() {
      if (!this.layer || this.loading) return;
      this.loading = true;

      const filters = this.useFilters ? this.columnFilters : {};
      const spatial = this.useFilters ? this.spatialFilter : null;

      await attributesTableService.downloadFeatures(
        this.layer,
        filters,
        spatial,
        this.format
      );

      this.loading = false;
      this.$modal.hide("DownloadModal");
    }
  }
};
</script>

<style scoped>
.modal-content {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: #2c3e50;
  font-family: 'Inter', sans-serif;
}

.modal-header {
  padding: 18px 24px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #1a1a1a;
}

.close-button {
  background: #f5f5f7;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 1.1rem;
  cursor: pointer;
  color: #666;
}

.modal-body {
  padding: 24px;
}

.description {
  margin-top: 0;
  margin-bottom: 20px;
  color: #7f8c8d;
  font-size: 0.95rem;
}

.option-section {
  margin-bottom: 24px;
}

.option-section label {
  display: block;
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #34495e;
}

.button-group {
  display: flex;
  gap: 10px;
}

.button-group button {
  flex: 1;
  padding: 10px;
  border: 1px solid #e0e0e0;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s;
}

.button-group button.active {
  background: #3c8dbc;
  border-color: #3c8dbc;
  color: white;
}

.selection-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.selection-card {
  padding: 14px;
  border: 2px solid #f0f0f0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.selection-card:hover {
  border-color: #3c8dbc33;
  background: #f9fbff;
}

.selection-card.active {
  border-color: #3c8dbc;
  background: #f0f7ff;
}

.card-title {
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 4px;
}

.card-desc {
  font-size: 0.85rem;
  color: #7f8c8d;
}

.limit-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: #fff9e6;
  border-radius: 8px;
  color: #856404;
  font-size: 0.85rem;
}

.modal-footer {
  padding: 18px 24px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: #fafafa;
}

.btn {
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.2s;
  border: none;
}

.btn-secondary {
  background: #e0e0e0;
  color: #333;
}

.btn-primary {
  background: #3c8dbc;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-primary:hover:not(:disabled) {
  background: #367fa9;
  transform: translateY(-1px);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
